import { AppContent } from '@/components/app-content';
import { AppHeader } from '@/components/app-header';
import { AppShell } from '@/components/app-shell';
import { AppSidebar } from '@/components/app-sidebar';
import { type BreadcrumbItem } from '@/types';
import type { PropsWithChildren } from 'react';

interface AppHeaderLayoutProps extends PropsWithChildren {
    breadcrumbs?: BreadcrumbItem[];
    contentClassName?: string;
}

export default function AppHeaderLayout({ children, breadcrumbs, contentClassName }: AppHeaderLayoutProps) {
    return (
        <AppShell>
            <AppHeader breadcrumbs={breadcrumbs} />
            <AppSidebar hideOnLarge />
            <AppContent className={contentClassName}>{children}</AppContent>
        </AppShell>
    );
}
